/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateTimesheetEntryDataTimesheetBreaksInner } from './CreateTimesheetEntryDataTimesheetBreaksInner';
import {
    CreateTimesheetEntryDataTimesheetBreaksInnerFromJSON,
    CreateTimesheetEntryDataTimesheetBreaksInnerFromJSONTyped,
    CreateTimesheetEntryDataTimesheetBreaksInnerToJSON,
    CreateTimesheetEntryDataTimesheetBreaksInnerToJSONTyped,
} from './CreateTimesheetEntryDataTimesheetBreaksInner';

/**
 * A template for the timesheet entries to be created
 * @export
 * @interface BulkCreateTimesheetEntryDataBaseTimesheetEntryData
 */
export interface BulkCreateTimesheetEntryDataBaseTimesheetEntryData {
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTimesheetEntryDataBaseTimesheetEntryData
     */
    employeeId?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTimesheetEntryDataBaseTimesheetEntryData
     */
    shiftId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTimesheetEntryDataBaseTimesheetEntryData
     */
    locationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTimesheetEntryDataBaseTimesheetEntryData
     */
    jobRoleId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof BulkCreateTimesheetEntryDataBaseTimesheetEntryData
     */
    startedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BulkCreateTimesheetEntryDataBaseTimesheetEntryData
     */
    endedAt?: Date;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkCreateTimesheetEntryDataBaseTimesheetEntryData
     */
    tags?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof BulkCreateTimesheetEntryDataBaseTimesheetEntryData
     */
    notes?: string | null;
    /**
     * 
     * @type {Array<CreateTimesheetEntryDataTimesheetBreaksInner>}
     * @memberof BulkCreateTimesheetEntryDataBaseTimesheetEntryData
     */
    timesheetBreaks?: Array<CreateTimesheetEntryDataTimesheetBreaksInner>;
}

/**
 * Check if a given object implements the BulkCreateTimesheetEntryDataBaseTimesheetEntryData interface.
 */
export function instanceOfBulkCreateTimesheetEntryDataBaseTimesheetEntryData(value: object): value is BulkCreateTimesheetEntryDataBaseTimesheetEntryData {
    return true;
}

export function BulkCreateTimesheetEntryDataBaseTimesheetEntryDataFromJSON(json: any): BulkCreateTimesheetEntryDataBaseTimesheetEntryData {
    return BulkCreateTimesheetEntryDataBaseTimesheetEntryDataFromJSONTyped(json, false);
}

export function BulkCreateTimesheetEntryDataBaseTimesheetEntryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCreateTimesheetEntryDataBaseTimesheetEntryData {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'shiftId': json['shiftId'] == null ? undefined : json['shiftId'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'jobRoleId': json['jobRoleId'] == null ? undefined : json['jobRoleId'],
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'endedAt': json['endedAt'] == null ? undefined : (new Date(json['endedAt'])),
        'tags': json['tags'] == null ? undefined : json['tags'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'timesheetBreaks': json['timesheetBreaks'] == null ? undefined : ((json['timesheetBreaks'] as Array<any>).map(CreateTimesheetEntryDataTimesheetBreaksInnerFromJSON)),
    };
}

  export function BulkCreateTimesheetEntryDataBaseTimesheetEntryDataToJSON(json: any): BulkCreateTimesheetEntryDataBaseTimesheetEntryData {
      return BulkCreateTimesheetEntryDataBaseTimesheetEntryDataToJSONTyped(json, false);
  }

  export function BulkCreateTimesheetEntryDataBaseTimesheetEntryDataToJSONTyped(value?: BulkCreateTimesheetEntryDataBaseTimesheetEntryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'shiftId': value['shiftId'],
        'locationId': value['locationId'],
        'jobRoleId': value['jobRoleId'],
        'startedAt': value['startedAt'] == null ? undefined : ((value['startedAt']).toISOString()),
        'endedAt': value['endedAt'] == null ? undefined : ((value['endedAt']).toISOString()),
        'tags': value['tags'],
        'notes': value['notes'],
        'timesheetBreaks': value['timesheetBreaks'] == null ? undefined : ((value['timesheetBreaks'] as Array<any>).map(CreateTimesheetEntryDataTimesheetBreaksInnerToJSON)),
    };
}

